// extracted by mini-css-extract-plugin
module.exports = {"Statuses__lifecycle-minor-statuses-container__36jR1":"Statuses__lifecycle-minor-statuses-container__36jR1","Statuses__icon__3QsrZ":"Statuses__icon__3QsrZ"};